import React from "react";
import { motion } from "framer-motion";
import CheckoutButton from "./CheckoutButton";

export default function MockupGallery() {
  return (
    <section
      data-testid="mockup-gallery-section"
      className="relative bg-[#849983] py-20 md:py-32 overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-50 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-14 items-center">
          <div className="lg:col-span-5 text-white">
            <p className="text-[11px] tracking-[0.22em] uppercase font-semibold text-white/70">
              Acceso completo
            </p>
            <h2 className="mt-4 font-serif-display text-4xl md:text-5xl tracking-tight leading-tight">
              Llévalo contigo en <em className="italic">cualquier dispositivo</em>.
            </h2>
            <p className="mt-6 text-base md:text-lg leading-relaxed text-white/85">
              Disfruta el ebook en tu celular, tablet o computadora. También puedes
              imprimir el planificador semanal y la lista de compras para tu cocina.
            </p>
            <ul className="mt-8 space-y-2.5 text-white/90 text-sm">
              <li>• Versión PDF para descarga inmediata</li>
              <li>• Optimizado para móvil y tablet</li>
              <li>• Planificadores imprimibles</li>
              <li>• Listas de compras semanales</li>
            </ul>
            <div className="mt-10">
              <CheckoutButton
                label="SÍ, QUIERO ALIMENTAR MEJOR A MI HIJO"
                testId="mockup-cta-button"
                variant="primary"
                size="xl"
              />
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="lg:col-span-7 relative"
          >
            <motion.img
              src="/img/mockup-hero.webp"
              alt="Ebook Pequeños Platos disponible en móvil, tablet y computadora"
              animate={{ y: [-6, 6, -6] }}
              transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
              className="w-full h-auto rounded-3xl drop-shadow-[0_40px_80px_rgba(0,0,0,0.35)]"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
